import { createFileRoute } from '@tanstack/react-router'
import { EquipmentInfo } from 'pages/inventoryManagement/EquipmentInfo'
import { z } from 'zod'
const equipmentSearchParams = z.object({
  mode: z.enum(['edit', 'create', 'view']).optional(),
})

export const Route = createFileRoute('/equipment/$equipmentID')({
  component: EquipmentInfo,
  staticData: {
    title: 'Equipment',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: true,
    },
  },
  validateSearch: equipmentSearchParams,
})
